import { useState, useEffect } from 'react';
import { useTranslate } from 'react-admin';
import  {Stack, Box, Dialog, DialogActions, DialogContent, Divider, DialogTitle, FormControlLabel, 
  Checkbox, RadioGroup, Radio, Button, TextField, NativeSelect } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import dataProvider from '../../lib/dataProvider';
import moment from 'moment';
import 'moment/dist/locale/de';

const ViewDialog = ({open, setOpen, viewSettings, setViewSettings, hostelsetting, setHostelsetting, localSettings, setLocalSettings}) => {
  const tr = useTranslate();
  const [saveView, setSaveView] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [roomkats, setRoomkats] = useState([]);

  useEffect(() => {
    dataProvider.getList('setRoom', { filter: {   }, sort: { field: 'pos', order: 'ASC' }, pagination: { page: 1, perPage: 999 }, })
      .then(response => { if (response.data) { setRooms(response.data);} 
    });
    dataProvider.getList('setRoomcategory', { filter: {   }, sort: { field: 'pos', order: 'ASC' }, pagination: { page: 1, perPage: 999 }, })
      .then(response => { if (response.data) { setRoomkats(response.data);} 
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const setAnzahlNaechte = (ev) => {
    setViewSettings((v)=>({...v, AnzahlNaechte:Number(ev.target.value)}))
  }

  const updateCheckbox = (f) => (ev) => {
    setViewSettings((v)=>({...v, [f]:ev.target.checked}))
  }

  const updateLocalCheckbox = (f) => (ev) => {
    setLocalSettings((v)=>({...v, [f]:ev.target.checked}))
  }

  const setStart = (date) => {
    const diff = moment(date).startOf('day').diff(moment().startOf('day'), 'days');
    setViewSettings((v)=>({...v, StartOffset:diff+1}))
  }

  const serRFilter = (typ) => (ev) => {
    if (typ==='cat') {
      setViewSettings({...viewSettings, Zimmerlist:false, ShowKat:''});
    }
    else {
      setViewSettings({...viewSettings, Zimmerlist:'', ShowKat:false});
    }
  }

  const filterchange = (ev) => {
    const name = ev.target.name;
    const selid = Number(name.substr(1));
    const chk = ev.target.checked;
    setViewSettings((vs)=> {
      if (name.substr(0,1)==='r') {
        const zl = (vs?.Zimmerlist)?vs.Zimmerlist.split(",").map(Number):[];
        if (chk) {
          zl.push(selid)
          return {...vs, Zimmerlist:zl.join(',')};
        }
        else {
          return {...vs, Zimmerlist:zl.filter(id => id !== selid).join(',')};
        }
      }
      else {
        const cl = (vs?.ShowKat)?vs.ShowKat.split(",").map(Number):[];
        if (chk) {
          cl.push(selid)
          return {...vs, ShowKat:cl.join(',')};
        }
        else {
          return {...vs, ShowKat:cl.filter(id => id !== selid).join(',')};
        }
  
      }
    })
  }

  const saveViewPosChange = (ev)=>{
    setSaveView({pos:ev.target.value, name:hostelsetting['view'+ev.target.value].Viewname})
  }

  const doSaveView = (ev)=>{
    dataProvider.update('appView', {id:saveView.pos, data:{name: saveView.name, settings: viewSettings} })
    .then(res  => {
        setHostelsetting({...hostelsetting, ['view'+saveView.pos]: {...viewSettings, Viewname:saveView.name}});
        setSaveView({pos:0, name:''})
    })
  }

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={handleClose}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Grid view</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label={tr('bw.cal.calendar.monthfrom')} value={moment().add(viewSettings.StartOffset, 'days')} onChange={setStart} />
            </LocalizationProvider>
            <TextField label="Number of days" type="number" value={viewSettings.AnzahlNaechte} onChange={setAnzahlNaechte} />
          </Stack>
          <RadioGroup defaultValue={viewSettings?.Zimmerlist!==false?'room':'cat'} row>
            <FormControlLabel value="cat" control={<Radio />} label="Room categories" onClick={serRFilter('cat')} />
            <FormControlLabel value="room" control={<Radio />} label="Rooms" onClick={serRFilter('room')}/>
          </RadioGroup>
          <Box sx={{maxHeight:'14em', border:'1px solid #888', borderRadius:'5px', p:1, '& .MuiButtonBase-root':{py:0}, overflow:'auto'}}>
            <Stack direction="row" flexWrap="wrap">
      {viewSettings?.Zimmerlist!==false && rooms.map((r)=> (
              <FormControlLabel key={0} control={<Checkbox checked={typeof viewSettings?.Zimmerlist === 'string' && viewSettings.Zimmerlist.split(",").map(Number).includes(r.id)} />} 
                name={"r"+r.id} onChange={filterchange} label={r.bezeichnung} sx={{width:'24%'}} />
      ))}
      {viewSettings?.ShowKat!==false && roomkats.map((r)=> (
              <FormControlLabel key={1} control={<Checkbox checked={typeof viewSettings?.ShowKat === 'string' && viewSettings.ShowKat.split(",").map(Number).includes(r.id)} />} 
                name={"c"+r.id} onChange={filterchange} label={r.bezeichnung} sx={{width:'32%'}}/>
      ))}
            </Stack>
          </Box>
          <Stack direction="row" spacing={2}>
            <FormControlLabel control={<Checkbox checked={viewSettings.ShowBedInfo} onChange={updateCheckbox('ShowBedInfo')} />} label="Display bed info" />
            <FormControlLabel control={<Checkbox checked={viewSettings.RoomView} onChange={updateCheckbox('RoomView')} />} label="Room view" />
            <FormControlLabel control={<Checkbox checked={viewSettings.ShowMatratzen} onChange={updateCheckbox('ShowMatratzen')} />} label="Display additional beds" />
          </Stack>
          <Stack direction="row" spacing={2}>
            <FormControlLabel control={<Checkbox checked={viewSettings.ShowInfos} onChange={updateCheckbox('ShowInfos')} />} label="Display reservation info" />
            <FormControlLabel control={<Checkbox checked={viewSettings.UseRoomColor} onChange={updateCheckbox('UseRoomColor')} />} label="Display room colors" />
          </Stack>
        </DialogContent>
        <DialogActions>
          {/*<Button variant="contained" color="primary">load View</Button>*/}
          <Stack direction="row" spacing={2}>
             <NativeSelect value={saveView.pos} onChange={saveViewPosChange}>
    {[...Array(13)].map((_,i) => (
                <option key={i} value={i}>{i===0?'--':'[F'+(i)+'] '+hostelsetting['view'+i]?.Viewname}</option>
    ))}
            </NativeSelect>
            <TextField label="View name" value={saveView.name} onChange={(ev)=>{setSaveView({...saveView, name:ev.target.value})}} InputLabelProps={{shrink:true}}/>
            <Button variant="contained" color="primary" onClick={doSaveView}>Save View</Button>
          </Stack>
        </DialogActions>
        <Divider />
        <DialogTitle sx={{pt:1, pb:0}}>Sidebar</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2}>
            <FormControlLabel control={<Checkbox checked={localSettings.legend!==false} onChange={updateLocalCheckbox('legend')} />} label="Legend" />
            <FormControlLabel control={<Checkbox checked={localSettings.arrivals!==false} />} onChange={updateLocalCheckbox('arrivals')} label="Arrivals" />
            <FormControlLabel control={<Checkbox checked={localSettings.departures!==false} onChange={updateLocalCheckbox('departures')} />} label="Departures" />
            <FormControlLabel control={<Checkbox checked={localSettings.reminders!==false} onChange={updateLocalCheckbox('reminders')}  />} label="Reminders" />
          </Stack>
        </DialogContent>
        <Divider />
        <DialogTitle sx={{pt:1, pb:0}}>Date groups</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2}>
            <FormControlLabel control={<Checkbox checked={localSettings.ogOnline!==false} onChange={updateLocalCheckbox('ogOnline')} />} label="Online" />
            <FormControlLabel control={<Checkbox checked={localSettings.ogPrices!==false} onChange={updateLocalCheckbox('ogPrices')} />} label="Prices" />
            <FormControlLabel control={<Checkbox checked={localSettings.ogServices!==false} onChange={updateLocalCheckbox('ogServices')} />} label="Services" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ViewDialog